import { Staff, Customer } from './types';

export const USER_DATA_KEY = 'userData';
export const JWT_KEY = 'jwtToken';
export const SELECTED_SITE_KEY = 'SELECTED_SITE';
export const REFRESH_TOKEN_KEY = 'REFRESH_TOKEN';
export const STAFF_ORDER_KEY = 'STAFF_ORDER'

export type UserType = Staff | Customer;

export default class LocalStorageSvc {
  public static save = <T>(key: string, value: T): void => {
    // Save to cookie instead of localStorage. Default expiration set to 7 days.
    const expires = new Date(Date.now() + 7 * 864e5).toUTCString();
    const isSecure = window.location.protocol === 'https:' ? 'Secure;' : '';
    document.cookie = `${key}=${encodeURIComponent(JSON.stringify(value))}; expires=${expires}; path=/; ${isSecure} SameSite=Strict`;
  };
  public static load = <T>(key: string): T | null => {
    const match = document.cookie.match(new RegExp('(?:^|; )' + key + '=([^;]*)'));
    const json = match ? decodeURIComponent(match[1]) : null;
    if (!json) {
      return null;
    }
    try {
      return JSON.parse(json) as T;
    } catch (e) {
      const error = e as Error;
      console.log(error);
      return null;
    }
  };
  public static remove = (key: string): void => {
    const isSecure = window.location.protocol === 'https:' ? 'Secure;' : '';
    document.cookie = `${key}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; ${isSecure} SameSite=Strict`;
  };
}

export const persistUser = (user: UserType | null): void => {
  // Wipe legacy localStorage data completely
  localStorage.removeItem(USER_DATA_KEY);
  localStorage.removeItem(JWT_KEY);
  localStorage.removeItem(REFRESH_TOKEN_KEY);
  localStorage.removeItem(SELECTED_SITE_KEY);
  localStorage.removeItem(STAFF_ORDER_KEY);

  if (!user) {
    LocalStorageSvc.remove(USER_DATA_KEY);
    LocalStorageSvc.remove(JWT_KEY);
    LocalStorageSvc.remove(REFRESH_TOKEN_KEY);
  } else {
    LocalStorageSvc.save(JWT_KEY, user.jwtToken);
    LocalStorageSvc.save(REFRESH_TOKEN_KEY, user.refreshToken);
    LocalStorageSvc.save(USER_DATA_KEY, user);
  }
};
